<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box">
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <v-toolbar flat class="toolbar" dense justify="center">
        <v-toolbar-title align="center">
          <strong> Management Employee Structure Report </strong>
        </v-toolbar-title>
      </v-toolbar>
      <v-row dense justify="center">
        <v-col sm="2">
          <v-icon color="error">*</v-icon>
          <v-autocomplete
            rounded
            dense
            required
            v-model="org"
            :items="org_list"
            item-text="name"
            return-object
            label="Organization"
            outlined
            @click="clear()"
          ></v-autocomplete>
        </v-col>
        <v-col sm="2">
          <v-btn
            rounded
            class="button mt-6"
            @click="getAllReport()"
            :loading="fetch_loader"
            >Fetch</v-btn
          >
        </v-col>
      </v-row>
      <v-toolbar
        v-if="org_designation_data_list != ''"
        class="toolbar"
        flat
        dense
      >
        <v-toolbar-title>
          <strong> Employee Designation Count </strong>
        </v-toolbar-title>
      </v-toolbar>
      <v-row dense v-if="org_designation_data_list != ''">
        <v-col cols="12" sm="6" md="6">
          <v-data-table
            :headers="headers"
            dense
            :items="org_designation_data_list"
            class="elevation-1 mytable"
          >
          </v-data-table>
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <center><chart :options="option"></chart></center>
        </v-col>
      </v-row>
      <v-toolbar v-if="org_emp_type_data_list != ''" class="toolbar" flat dense>
        <v-toolbar-title>
          <strong> Employee Type Count </strong>
        </v-toolbar-title>
      </v-toolbar>
      <v-row dense v-if="org_emp_type_data_list != ''">
        <v-col cols="12" sm="6" md="6">
          <v-data-table
            :headers="headers1"
            dense
            :items="org_emp_type_data_list"
            class="elevation-1 mytable"
          >
          </v-data-table>
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <center><chart :options="option1"></chart></center>
        </v-col>
      </v-row>

      <v-toolbar
        v-if="org_gender_type_data_list != ''"
        class="toolbar"
        flat
        dense
      >
        <v-toolbar-title>
          <strong> Employee Gender Type Count </strong>
        </v-toolbar-title>
      </v-toolbar>
      <v-row dense v-if="org_gender_type_data_list != ''">
        <v-col cols="12" sm="6" md="6">
          <v-data-table
            :headers="headers2"
            dense
            :items="org_gender_type_data_list"
            class="elevation-1 mytable"
          >
          </v-data-table>
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <center><chart :options="option2"></chart></center>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  data() {
    return {
      all_toggle: false,
      loader: false,
      overlay: false,
      color: "",
      snackbar: false,
      search: null,
      snackbar_msg: null,
      fees_structure_data: null,
      current_academic_year: null,
      stream: null,
      header: null,
      standard_list: null,
      dision_list: null,
      org_list: null,
      org: null,
      display_data: false,
      org_designation_data_list: [],
      division_list: [],
      dialog: false,
      org_data: [],
      fetch_loader: false,
      org_emp_type_data_list: [],
      org_gender_type_data_list: [],
      headers: [
        {
          text: "Sr. No.",
          sortable: false,
          value: "srno",
        },
        {
          text: "Designation",
          align: "center",
          sortable: false,
          value: "designation_name",
        },
        {
          text: "Employee Count",
          align: "center",
          sortable: false,
          value: "designation_info",
        },
      ],
      headers1: [
        {
          text: "Sr. No.",
          sortable: false,
          value: "srno",
        },
        {
          text: "Employee Type",
          align: "center",
          sortable: false,
          value: "type_name",
        },
        {
          text: "Employee Count",
          align: "center",
          sortable: false,
          value: "type_info",
        },
      ],
      headers2: [
        {
          text: "Sr. No.",
          sortable: false,
          value: "srno",
        },
        {
          text: "Gender",
          align: "center",
          sortable: false,
          value: "gender_name",
        },
        {
          text: "Instructor Count",
          align: "center",
          sortable: false,
          value: "gender_count",
        },
      ],
      option: {
        height: "300px",
        color: ["#3398DB"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
            label: {
              show: true,
            },
          },
        },
        toolbox: {
          show: true,
          feature: {
            mark: { show: true },
            magicType: {
              show: true,
              type: ["line", "bar", "stack"],
              title: {
                line: "Switch to Line Chart",
                bar: "Switch to Bar Chart",
                stack: "Switch to Stack Chart",
              },
            },
            restore: { show: true, title: "Restore" },
            saveAsImage: {
              show: true,
              title: "Save As Image",
            },
            dataView: {
              show: true,
              title: "Data View",
              readonly: false,
            },
          },
        },
        calculable: true,
        legend: {
          data: [],
          itemGap: 5,
        },
        grid: {
          top: "12%",
          left: "6%", // change from 1% by shiv
          right: "16%", // change from 10% by shiv
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: [],
          axisLabel: {
            margin: 15,
            rotate: 45,
          },
          name: "Designation",
          nameLocation: "end",
          offset: 10,
        },
        yAxis: {
          type: "value",
          name: "Count",
          nameLocation: "end",
          offset: 10,
        },
        legend: {
          data: ["X-axis:Designation", "Y-axis:# Employee Count"],
          show: true,
        },
        series: [
          {
            data: [],
            value: [],
            type: "bar",
            //name:'Direct'
          },
        ],
        // series: [{ type: 'bar' }, { type: 'bar' }, { type: 'bar' }]
      },
      option1: {
        height: "300px",
        color: ["#3398DB"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
            label: {
              show: true,
            },
          },
        },
        toolbox: {
          show: true,
          feature: {
            mark: { show: true },
            magicType: {
              show: true,
              type: ["line", "bar", "stack"],
              title: {
                line: "Switch to Line Chart",
                bar: "Switch to Bar Chart",
                stack: "Switch to Stack Chart",
              },
            },
            restore: { show: true, title: "Restore" },
            saveAsImage: {
              show: true,
              title: "Save As Image",
            },
            dataView: {
              show: true,
              title: "Data View",
              readonly: false,
            },
          },
        },
        calculable: true,
        legend: {
          data: [],
          itemGap: 5,
        },
        grid: {
          top: "12%",
          left: "6%", // change from 1% by shiv
          right: "16%", // change from 10% by shiv
          bottom: " 3%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: [],
          axisLabel: {
            margin: 15,
            rotate: 45,
          },
          name: "Type",
          nameLocation: "end",
          offset: 10,
        },
        yAxis: {
          type: "value",
          name: "Count",
          nameLocation: "end",
          offset: 10,
        },
        legend: {
          data: ["X-axis:Employee Type", "Y-axis:# Employee Count"],
          show: true,
        },
        series: [
          {
            data: [],
            value: [],
            type: "bar",
            //name:'Direct'
          },
        ],
        // series: [{ type: 'bar' }, { type: 'bar' }, { type: 'bar' }]
      },

      option2: {
        height: "300px",
        color: ["#3398DB"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
            label: {
              show: true,
            },
          },
        },
        toolbox: {
          show: true,
          feature: {
            mark: { show: true },
            magicType: {
              show: true,
              type: ["line", "bar", "stack"],
              title: {
                line: "Switch to Line Chart",
                bar: "Switch to Bar Chart",
                stack: "Switch to Stack Chart",
              },
            },
            restore: { show: true, title: "Restore" },
            saveAsImage: {
              show: true,
              title: "Save As Image",
            },
            dataView: {
              show: true,
              title: "Data View",
              readonly: false,
            },
          },
        },
        calculable: true,
        legend: {
          data: [],
          itemGap: 5,
        },
        grid: {
          top: "12%",
          left: "6%", // change from 1% by shiv
          right: "16%", // change from 10% by shiv
          bottom: " 3%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: [],
          axisLabel: {
            margin: 15,
            rotate: 45,
          },
          name: "Type",
          nameLocation: "end",
          offset: 10,
        },
        yAxis: {
          type: "value",
          name: "Count",
          nameLocation: "end",
          offset: 10,
        },
        legend: {
          data: ["X-axis:Gender Type", "Y-axis:# Gender Count"],
          show: true,
        },
        series: [
          {
            data: [],
            value: [],
            type: "bar",
            //name:'Direct'
          },
        ],
        // series: [{ type: 'bar' }, { type: 'bar' }, { type: 'bar' }]
      },
    };
  },

  methods: {
    clear() {
      this.org_data_list = [];
    },
    getAllReport() {
      this.fetch_loader = true;
      const data = {
        org: this.org,
      };
      axios
        .post("/Management/getInstructorStructureReport", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.org_designation_data_list = res.data.org_designation_data_list;
            this.org_emp_type_data_list = res.data.org_emp_type_data_list;
            this.org_gender_type_data_list = res.data.org_gender_type_data_list;

            this.option.series[0].data = res.data.designation_value;
            this.option.xAxis.data = res.data.designation_data;
            this.option.series[0].label = {
              normal: {
                show: true,
                position: "top",
                formatter: (params) => {
                  let outof = this.option.series[0].value[params.dataIndex];
                  return outof;
                },
              },
            };

            this.option1.series[0].data = res.data.emp_type_value;
            this.option1.xAxis.data = res.data.emp_type_data;
            this.option1.series[0].label = {
              normal: {
                show: true,
                position: "top",
                formatter: (params) => {
                  let outof = this.option1.series[0].value[params.dataIndex];
                  return outof;
                },
              },
            };

            this.option2.series[0].data = res.data.gender_type_value;
            this.option2.xAxis.data = res.data.gender_type_data;
            this.option2.series[0].label = {
              normal: {
                show: true,
                position: "top",
                formatter: (params) => {
                  let outof = this.option2.series[0].value[params.dataIndex];
                  return outof;
                },
              },
            };

            this.fetch_loader = false;
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong!");
            this.fetch_loader = false;
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!");
          this.fetch_loader = false;
        })
        .finally(() => {
          //close loader
          this.fetch_loader = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    onload() {
      axios
        .post("/Management/getOrg_without_all")
        .then((res) => {
          if (res.data.flag == "YES") {
            this.org_list = res.data.org_list;
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!");
        })
        .finally(() => {
          //close loader
        });
    },
  },
  mounted() {
    this.onload();
  },
};
</script>
<style scoped>
.mytable /deep/ thead th {
  background: #0f2027 !important; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ) !important; /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  background-color: #0f2027 !important;
  color: white !important;
  font-weight: bold !important;
  white-space: nowrap !important;
  text-align: center;
}
.btn-css {
  outline: 0 !important;
  outline-offset: 0 !important;
  background-image: none !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  background-color: #fff !important;
  text-decoration: underline;
  color: #0f2027 !important;
  text-align: center;
}

.btn-css:hover {
  outline: 0 !important;
  outline-offset: 0 !important;
  background-image: none !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  background-color: #ffff !important;
  color: #0f2027 !important;
  text-decoration: underline;
  text-align: center;
}
tr,
td,
th {
  border: 1px solid #ccc;
  text-align: center;
  font-size: small;
}
tr,
tbody {
  border-bottom: 1px solid #ccc;
  border: 1px solid #ccc;
  font-size: small;
}
td {
  margin: 0.3rem !important;
  padding: 0.4rem !important;
  font-size: small;
}
@media (min-width: 320px) {
  td,
  th {
    display: table-cell !important;
    font-size: small;
  }
  td + td,
  th + th {
    width: auto;
    font-size: small;
  }
}
v-simple-table {
  white-space: nowrap !important;
  text-align: center;
  font-size: small;
}
</style>
